import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { changeBmapAction } from "../../redux/ui/actions";

const bmapData = [
    { value: "std", text: "標準地図", info: "出典：国土地理院" },
    { value: "pale", text: "淡色地図", info: "出典：国土地理院" },
    { value: "blank", text: "白地図", info: "出典：国土地理院" },
    { value: "shade", text: "白地図 + 陰影", info: "出典：国土地理院" },
    //{value: 'OB', text: 'Ocean Basemap', info: '出典：Esri'},
    //        {value: 'GRM', text: 'Global Relief Model', info: '「Global Relief Model」(出典：NOAA)をジーエムラボ株式会社が加工したものです。'}
];

const mapStateToProps = (state) => {
    return {
        bmap: state.uiReducer.bmap,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);
        this.changeMap = this.changeMap.bind(this);
    }

    /*
     * マップ変更
     * @param {Event} e イベント情報
     * @since hara 2020-09-09
     */
    changeMap(e) {
        const mapCat = e.target.value;
        window.changeBmap(mapCat);
        this.props.dispatch(changeBmapAction(mapCat));
    }

    render() {
        return (
            <div className="TopBtnSwS">
                <ul>
                    {bmapData.map((el, index) => (
                        <li className={index === 0 ? "l-right" : "l-right l-mtSS"} key={index}>
                            <p className="l-left">
                                <input id={"bmap_" + el.value} className="radio" value={el.value} name="basemap" type="radio" checked={this.props.bmap === el.value} onChange={this.changeMap} />
                                <label htmlFor={"bmap_" + el.value}>{el.text}</label>
                            </p>
                            {/*
                            <a className='infoBtn l-blank' href={'https://maps.gsi.go.jp/development/ichiran.html'} target="_blank" data-tip={el.info}></a>
                                <ReactTooltip effect='float' />
                            */}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Main);
